import { render, staticRenderFns } from "./StarExplosion.vue?vue&type=template&id=5cd25a52&"
import script from "./StarExplosion.vue?vue&type=script&lang=js&"
export * from "./StarExplosion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd25a52')) {
      api.createRecord('5cd25a52', component.options)
    } else {
      api.reload('5cd25a52', component.options)
    }
    module.hot.accept("./StarExplosion.vue?vue&type=template&id=5cd25a52&", function () {
      api.rerender('5cd25a52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/StarExplosion.vue"
export default component.exports